import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "text-white flex-1 col-span-1 border-0 overflow-hidden overflow-y-auto h-auto" }
const _hoisted_3 = { class: "pt-3 px-[16px] py-[16px]" }
const _hoisted_4 = {
  key: 1,
  class: "relative pb-3 col-partition-border"
}
const _hoisted_5 = { class: "flex justify-between items-center pt-2" }
const _hoisted_6 = { class: "flex large:flex-row flex-col justify-between large:gap-3 py-1" }
const _hoisted_7 = { class: "w-full xl:w-1/3 flex items-center" }
const _hoisted_8 = { class: "input-wrapper w-[120px] flex items-center lg:mt-0 mt-5 large:h-[50px] large:mb-0 mb-3" }
const _hoisted_9 = ["id", "onUpdate:modelValue"]
const _hoisted_10 = ["for"]
const _hoisted_11 = { class: "w-full xl:w-1/3" }
const _hoisted_12 = {
  class: /*@__PURE__*/_normalizeClass('input-wrapper large:mb-0 mb-3')
}
const _hoisted_13 = { class: "block rounded bg-gray-black w-full relative" }
const _hoisted_14 = { class: "bg-gray-black flex items-center w-full pr-[60px] rounded py-2" }
const _hoisted_15 = ["onChange", "onUpdate:modelValue"]
const _hoisted_16 = ["value"]
const _hoisted_17 = ["onChange", "onUpdate:modelValue"]
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "flex items-center cursor-pointer absolute right-2 top-2" }
const _hoisted_20 = ["onChange", "onUpdate:modelValue"]
const _hoisted_21 = { class: "w-full xl:w-1/3" }
const _hoisted_22 = {
  class: /*@__PURE__*/_normalizeClass('input-wrapper large:mb-0 mb-3')
}
const _hoisted_23 = { class: "block rounded bg-gray-black w-full relative" }
const _hoisted_24 = { class: "bg-gray-black flex items-center w-full pr-[60px] rounded py-2" }
const _hoisted_25 = ["onChange", "onUpdate:modelValue"]
const _hoisted_26 = ["value"]
const _hoisted_27 = ["onChange", "onUpdate:modelValue"]
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "flex items-center cursor-pointer absolute right-2 top-2" }
const _hoisted_30 = ["onChange", "onUpdate:modelValue"]
const _hoisted_31 = {
  key: 0,
  class: "text-theme-red w-full text-end text-xs"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_block_loading = _resolveComponent("block-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_block_loading, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "text-white font-semibold text-[24px]" }, "Store Hours", -1)),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.save()), ["prevent"])),
                  class: "bg-white text-theme-green rounded mt-2 px-4 py-2 hover:bg-theme-darkgreen hover:text-white"
                }, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("span", { class: "text-sm tracking-widest font-medium" }, "SAVE", -1)
                ]))])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.operationHours, (day, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index + 'opening_hours',
                  class: ""
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: day.dayName + index,
                          "onUpdate:modelValue": ($event: any) => ((day.isOpen) = $event),
                          value: "1",
                          class: "w-4 h-4 text-theme-green bg-transparent border-white focus:ring-theme-green"
                        }, null, 8, _hoisted_9), [
                          [_vModelCheckbox, day.isOpen]
                        ]),
                        _createElementVNode("label", {
                          for: day.dayName + index,
                          class: "ml-2 cursor-pointer text-sm font-bold tracking-wider text-white"
                        }, _toDisplayString(day.dayName), 9, _hoisted_10)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass('flex large:flex-row flex-col large:space-x-2 w-full lg:pb-6' + (day.isOpen ? '' : ' invisible'))
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _cache[4] || (_cache[4] = _createElementVNode("label", { class: "text-xs font-normal mb-1" }, "Start Time", -1)),
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _withDirectives(_createElementVNode("select", {
                                onChange: _withModifiers(($event: any) => (_ctx.validateStartEndTime(index)), ["prevent"]),
                                "onUpdate:modelValue": ($event: any) => ((day.openTime.HH) = $event),
                                class: "bg-gray-black border-0 focus:border-transparent focus:ring-0 text-sm w-[100px] pl-2 py-0 pr-0 sm-arrow"
                              }, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (hour) => {
                                  return _createElementVNode("option", {
                                    value: hour > 9 ? hour : '0'+hour,
                                    key: hour + 'hour'
                                  }, _toDisplayString(hour > 9 ? hour : '0'+hour), 9, _hoisted_16)
                                }), 64))
                              ], 40, _hoisted_15), [
                                [_vModelSelect, day.openTime.HH]
                              ]),
                              _cache[3] || (_cache[3] = _createElementVNode("span", null, ":", -1)),
                              _withDirectives(_createElementVNode("select", {
                                onChange: _withModifiers(($event: any) => (_ctx.validateStartEndTime(index)), ["prevent"]),
                                "onUpdate:modelValue": ($event: any) => ((day.openTime.MM) = $event),
                                class: "bg-gray-black focus:border-transparent focus:ring-0 border-0 text-sm w-[100px] py-0 pl-2 pr-0 sm-arrow"
                              }, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(60, (key, min) => {
                                  return _createElementVNode("option", {
                                    value: min > 9 ? min : '0'+min,
                                    key: min + 'min'
                                  }, _toDisplayString(min > 9 ? min : '0'+min), 9, _hoisted_18)
                                }), 64))
                              ], 40, _hoisted_17), [
                                [_vModelSelect, day.openTime.MM]
                              ])
                            ]),
                            _createElementVNode("label", _hoisted_19, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                onChange: _withModifiers(($event: any) => (_ctx.validateStartEndTime(index)), ["prevent"]),
                                "onUpdate:modelValue": ($event: any) => ((day.openTimeTypeAm) = $event),
                                class: "hidden peer"
                              }, null, 40, _hoisted_20), [
                                [_vModelCheckbox, day.openTimeTypeAm]
                              ]),
                              _createElementVNode("div", {
                                class: _normalizeClass('relative toggle-bg ampm-inside-switch border-2  h-6 w-[50px] rounded-full ' + (day.openTimeTypeAm ? 'bg-theme-darkgreen border-theme-green' : 'bg-theme-darkgreen  border-theme-green'))
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass('text-white  text-xs leading-loose ' + (day.openTimeTypeAm ? 'left' : 'right'))
                                }, _toDisplayString(day.openTimeTypeAm ? 'AM' : 'PM'), 3)
                              ], 2)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _cache[6] || (_cache[6] = _createElementVNode("label", { class: "text-xs font-normal mb-1" }, "End Time", -1)),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _withDirectives(_createElementVNode("select", {
                                onChange: _withModifiers(($event: any) => (_ctx.validateStartEndTime(index)), ["prevent"]),
                                "onUpdate:modelValue": ($event: any) => ((day.closeTime.HH) = $event),
                                class: "bg-gray-black border-0 focus:border-transparent focus:ring-0 text-sm w-[100px] pl-2 py-0 pr-0 sm-arrow"
                              }, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (hour) => {
                                  return _createElementVNode("option", {
                                    value: hour > 9 ? hour : '0'+hour,
                                    key: hour + 'hour'
                                  }, _toDisplayString(hour > 9 ? hour : '0'+hour), 9, _hoisted_26)
                                }), 64))
                              ], 40, _hoisted_25), [
                                [_vModelSelect, day.closeTime.HH]
                              ]),
                              _cache[5] || (_cache[5] = _createElementVNode("span", null, ":", -1)),
                              _withDirectives(_createElementVNode("select", {
                                onChange: _withModifiers(($event: any) => (_ctx.validateStartEndTime(index)), ["prevent"]),
                                "onUpdate:modelValue": ($event: any) => ((day.closeTime.MM) = $event),
                                class: "bg-gray-black focus:border-transparent focus:ring-0 border-0 text-sm w-[100px] py-0 pl-2 pr-0 sm-arrow"
                              }, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(60, (key, min) => {
                                  return _createElementVNode("option", {
                                    value: min > 9 ? min : '0'+min,
                                    key: min + 'min'
                                  }, _toDisplayString(min > 9 ? min : '0'+min), 9, _hoisted_28)
                                }), 64))
                              ], 40, _hoisted_27), [
                                [_vModelSelect, day.closeTime.MM]
                              ])
                            ]),
                            _createElementVNode("label", _hoisted_29, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                onChange: _withModifiers(($event: any) => (_ctx.validateStartEndTime(index)), ["prevent"]),
                                "onUpdate:modelValue": ($event: any) => ((day.closeTimeTypeAm) = $event),
                                class: "hidden peer"
                              }, null, 40, _hoisted_30), [
                                [_vModelCheckbox, day.closeTimeTypeAm]
                              ]),
                              _createElementVNode("div", {
                                class: _normalizeClass('relative toggle-bg ampm-inside-switch border-2  h-6 w-[50px] rounded-full ' + (day.closeTimeTypeAm ? 'bg-theme-darkgreen border-theme-green' : 'bg-theme-darkgreen  border-theme-green'))
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass('text-white  text-xs leading-loose ' + (day.closeTimeTypeAm ? 'left' : 'right'))
                                }, _toDisplayString(day.closeTimeTypeAm ? 'AM' : 'PM'), 3)
                              ], 2)
                            ])
                          ])
                        ])
                      ])
                    ], 2)
                  ]),
                  (day.is_valid_openTime_closeTime == false)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_31, "End time must be greater than start time."))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
      ])
    ])
  ]))
}